// extracted by mini-css-extract-plugin
export var deleteIcon = "_tk-5";
export var deleteOption = "_tk-3";
export var divider = "_tk-2";
export var downloadIcon = "_tk-4";
export var drawer = "_tk-0";
export var drawerFooter = "_tk-6";
export var drawerOpen = "_tk-1";
export var highlighted = "_tk-7";
export var lighterHighlight = "_tk-8";